import constants from '../constants';

const getGlobalSource = (serializedGlobal) => {
  const matches = serializedGlobal.match(constants.regularExpressions.WS_GLOBAL_SOURCE);
  if (matches === null) return null;

  return matches[1];
};

export default getGlobalSource;
